import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { purpurColorFunctionalWhite } from '@purpurds/tokens/color/variables';
export const FullscreenLayoutBase = styled.div `
  background-color: ${purpurColorFunctionalWhite};
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;
const MainScreen = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
const MainContent = styled.main `
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  padding-top: 0;
`;
export const ScreenLayout = ({ children }) => (_jsx(FullscreenLayoutBase, { children: _jsx(MainScreen, { children: _jsx(MainContent, { children: children }) }) }));
